export class VumarkToolViewModel {
  public campus: number = 0;
  public komplex: number = 0;
  public gebaeudenummer: number = 20;
  public stockwerk: number = 2;
  public raumnummer: number = 7;
  public id: string = '';

  public campusValues = [
    {
      value: 0,
      viewValue: 'Gießen',
    },
    {
      value: 1,
      viewValue: 'Friedberg',
    },
    {
      value: 2,
      viewValue: 'Wetzlar',
    },
    {
      value: 3,
      viewValue: 'Andere',
    },
  ];

  public komplexValues = [
    {
      value: 0,
      viewValue: 'A',
    },
    {
      value: 1,
      viewValue: 'B',
    },
    {
      value: 2,
      viewValue: 'C',
    },
    {
      value: 3,
      viewValue: 'D',
    },
    {
      value: 4,
      viewValue: 'E',
    },
    {
      value: 5,
      viewValue: 'F',
    },
    {
      value: 6,
      viewValue: 'G',
    },
    {
      value: 7,
      viewValue: 'H',
    },
    {
      value: 8,
      viewValue: 'I',
    },
    {
      value: 9,
      viewValue: 'J',
    },
    {
      value: 10,
      viewValue: 'K',
    },
    {
      value: 11,
      viewValue: 'L',
    },
    {
      value: 12,
      viewValue: 'M',
    },
    {
      value: 13,
      viewValue: 'N',
    },
    {
      value: 14,
      viewValue: 'O',
    },
    {
      value: 15,
      viewValue: 'P',
    },
  ];
}
